module.exports = __webpack_public_path__ + "assets/bell_icn_2@1x.765a78b9.svg";